import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

export const useAuth = () => {
  const navigate = useNavigate();

  const login = useMutation({
    mutationFn: authService.login,
    onSuccess: (data) => {
      localStorage.setItem('accessToken', data.access_token);
      localStorage.setItem('refreshToken', data.refresh_token);
      localStorage.setItem('tokenExpires', data.expires_in.toString());
      localStorage.setItem('userRoles', JSON.stringify(data.roles));
      localStorage.setItem('isAuthenticated', 'true');
      navigate('/products');
    },
    onError: (error) => {
      console.error('Login failed:', error);
    }
  });

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tokenExpires');
    localStorage.removeItem('userRoles');
    localStorage.removeItem('isAuthenticated');
    navigate('/login');
  };

  return { 
    login, 
    logout,
    isLoading: login.isPending,
    error: login.error 
  };
}; 